import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Moment from 'react-moment';

import Hor_header from "../header/hor_header";
import Ver_header from "../header/ver_header";
import Footer from "../footer/footer";

import { API_URL } from "../constant";
import Loader from "./loading";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';

import DataTable from 'react-data-table-component';

import "react-data-table-component-extensions/dist/index.css";

import { toExcel } from 'to-excel';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

function AllRecoveredList() {

    const navigat = useNavigate();

    const [userData, setUserData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [pages, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [totalData, setTotalData] = useState();
    const [searchText, setSearchText] = useState("");
  //   const [totalDetails, setTotalDetails] = useState([]);




    useEffect(() => {
        document.title = "Recovered List";
        getTotalPatientData()

    }, [1]
    );

    useEffect(() => {

        getAllPatientData(pages);

    }, [pages]);




    /************Get all patient user********************** */
    let getAllPatientData = async (page) => {
      
        let datas = { page: page, per_page: perPage };
        var url = "";

        url = 'admin/getServerSideRecoveredBeneficiaries';


        const res = await axios.post(API_URL + url, datas)
            .then(ress => {
               
                setUserData(ress.data.Rdata);
               
            });
      
    }

    /************Get total user********************** */
    let getTotalPatientData = async () => {


        let datas = {};
       
        var url = "";

        url = 'admin/getServerSideRecoveredBeneficiariesTotal';

        const res = await axios.post(API_URL + url, datas)
            .then(ress => {
               
                setTotalRows(ress.data.Rdata.length);
                setTotalData(ress.data.Rdata);
                setIsLoading(false);

            });


    }


    const fetchUsers = async page => {
        setLoading(true);
        getAllPatientData(page);
        setLoading(false);
    };

    const handlePageChange = page => {
        fetchUsers(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        setLoading(true);
        getAllPatientData(page)
        setPerPage(newPerPage);
        setLoading(false);
    };




    var headers = [
        { label: 'Name', field: 'name' },
        { label: 'Beneficiary Type', field: 'beneficiary_type' },
        { label: 'Patient id', field: 'patient_id' },
        { label: 'Family Head Name', field: 'guardian_name' },
        { label: 'Mobile No', field: 'mobile_no' },
        { label: 'Gender', field: 'gender' },
        { label: 'Caste', field: 'caste' },
        { label: 'Age id', field: 'age' },
        { label: 'Pregnancy Duration', field: 'preg_duration' },
        { label: 'Address', field: 'address' },
        { label: 'Staff Type', field: 'staff_type' },
        { label: 'Added By Anm/Medical Team Id', field: 'anm_teacher_id' },
        { label: 'Tested By', field: 'treatment_giv_name' },
        { label: 'Designation', field: 'degs' },
        { label: 'Rch id', field: 'rch_uid' },
        { label: 'District', field: 'district_name' },
        { label: 'Block', field: 'block_name' },
        { label: 'CHC/PHC', field: 'chc_name' },
        { label: 'Village', field: 'village_name' },
        { label: 'School', field: 'school_name' },
        { label: 'Haemoglobin value', field: 'haemoglobin_value' },
        { label: 'Haemoglobin based status', field: 'haemoglobin_based_status' },
        { label: 'Height', field: 'height' },
        { label: 'Weight', field: 'weight' },
        { label: 'BMI value', field: 'bmi_value' },
        { label: 'BMI Status', field: 'bmi_category' },
        { label: 'Pregnancy Duration(At time of test)', field: 'pregnancy_duration' },
        { label: 'Latitude', field: 'ts_lat' },
        { label: 'Longitude', field: 'ts_log' },
        { label: 'Venue', field: 'venue' },
        { label: 'Current Address', field: 'curr_address' },
        { label: 'Referral status', field: 'referral_status' },
        { label: 'Referred At', field: 'referred_center_name' },
        { label: 'Test done on', field: 'investigated_on' },
        { label: 'Test Done By (Not ref.)', field: 'anm_teacher_id' },
        { label: 'Test Done By (ref.)', field: 'test_hos_name' },
        { label: 'Referred By Hospital', field: 'referred_by_hos_name' },
       
        { label: 'Added On', field: 'added_on' },

    ]


    const dwn = () => {

        var content = toExcel.exportXLS(headers, totalData, 'AllRecoveredBeneficiaryData');
      
    }



    
   
    
      // Add header
    const col = [
        { header: 'Name', key: 'name' },
        { header: 'Beneficiary Type', key: 'beneficiary_type' },
        { header: 'Patient id', key: 'patient_id' },
        { header: 'Family Head Name', key: 'guardian_name' },
        { header: 'Mobile No', key: 'mobile_no' },
        { header: 'Gender', key: 'gender' },
        { header: 'Caste', key: 'caste' },
        { header: 'Age id', key: 'age' },
        { header: 'Pregnancy Duration', key: 'preg_duration' },
        { header: 'Address', key: 'address' },
        { header: 'Staff Type', key: 'staff_type' },
        { header: 'Added By Anm/Medical Team Id', key: 'amn_teacher_u_id' },
        { header: 'Tested By', key: 'treatment_giv_name' },
        { header: 'Designation', key: 'degs' },
        { header: 'Rch id', key: 'rch_uid' },
        { header: 'District', key: 'district_name' },
        { header: 'Block', key: 'block_name' },
        { header: 'CHC/PHC', key: 'chc_name' },
        { header: 'Village', key: 'village_name' },
        { header: 'School', key: 'school_name' },
        { header: 'Haemoglobin value', key: 'haemoglobin_value' },
        { header: 'Haemoglobin based status', key: 'haemoglobin_based_status' },
        { header: 'Height', key: 'height' },
        { header: 'Weight', key: 'weight' },
        { header: 'BMI value', key: 'bmi_value' },
        { header: 'BMI Status', key: 'bmi_category' },
        { header: 'Pregnancy Duration(At time of test)', key: 'pregnancy_duration' },
        { header: 'Latitude', key: 'ts_lat' },
        { header: 'Longitude', key: 'ts_log' },
        { header: 'Venue', key: 'venue' },
        { header: 'Current Address', key: 'curr_address' },
        { header: 'Referral status', key: 'referral_status' },
        { header: 'Referred At', key: 'referred_center_name' },
        { header: 'Test done on', key: 'investigated_on' },
        { header: 'Test Done By (Not ref.)', key: 'anm_teacher_id' },
        { header: 'Test Done By (ref.)', key: 'test_hos_name' },
        { header: 'Referred By Hospital', key: 'referred_by_hos_name' },
       
        { header: 'Added On', key: 'added_on' },

    ]

   const   dwnDetail = async() => {
        setIsLoading(true);
          const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('PatientData');
        worksheet.columns=col;
        let lastId = null;
         let colorToggle = false;
         const colorMap = {
           true: 'FFEB9C',  // light yellow
           false: 'C6EFCE'  // light green
         };
          
         //api call
          const res = await axios.post(API_URL + 'admin/getRecoveredBeneficiariesDetails',)
            .then(ress => {
              
               if(ress.data.Rdata.length){
                     ress.data.Rdata.forEach(row => {
                        const isSame = row.patient_id === lastId;
                        if (!isSame) colorToggle = !colorToggle;
                        lastId = row.patient_id;
                    
                        const addedRow = worksheet.addRow(row);
                        addedRow.eachCell((cell) => {
                            cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: colorMap[colorToggle] }
                            };
                        });
                        });
                   }
               
                setIsLoading(false);

            });


        
           worksheet.getRow(1).eachCell((cell) => {
         cell.font = { bold: true };
         cell.fill = {
           type: 'pattern',
           pattern: 'solid',
           fgColor: { argb: 'CCCCFF' }  // Light purple background
         };
       });
       
         // Export
        
         workbook.xlsx.writeBuffer().then((buffer) => {
           const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
           saveAs(blob, 'AllRecoveredBeneficiaryDetailData.xlsx');
         });
    }



    const ExpandedComponent = ({ data }) => {
        return (

            <>
                <table className='table table-striped  sadi'>
                    <tr><td> <b>Pregnancy Duration - </b>  {data.preg_duration}</td></tr>

                    <tr><td> <b>Address</b>  - {data.address}</td></tr>
                    <tr><td> <b>Staff Type - </b> {data.staff_type}</td></tr>
                    <tr><td> <b>Added By Anm/Medical Team Id - </b> {data.anm_teacher_id}</td></tr>
                    <tr><td> <b>Tested By - </b> {data.treatment_giv_name}</td></tr>
                    <tr><td> <b>Designation - </b> {data.degs}</td></tr>
                    <tr><td> <b>Rch id - </b> {data.rch_uid}</td></tr>
                    <tr><td> <b>District - </b> {data.district_name}</td></tr>
                    <tr><td> <b>Block - </b> {data.block_name}</td></tr>
                    <tr><td> <b>CHC/PHC - </b> {data.chc_name}</td></tr>
                    <tr><td> <b>Village - </b> {data.village_name}</td></tr>
                    <tr><td> <b>School - </b> {data.school_name}</td></tr>
                    <tr><td> <b>Haemoglobin value - </b> {data.haemoglobin_value}</td></tr>
                    <tr><td> <b>Haemoglobin based status - </b> {data.haemoglobin_based_status != null ? data.haemoglobin_based_status.toUpperCase() : ""}</td></tr>

                    <tr><td> <b>Height - </b> {data.height}</td></tr>
                    <tr><td> <b>Weight - </b> {data.weight}</td></tr>
                    <tr><td> <b>BMI value - </b> {data.bmi_value}</td></tr>
                    <tr><td> <b>BMI Status - </b>{data.bmi_category}</td></tr>
                    <tr><td> <b>Pregnancy Duration(At time of test) - </b> {data.pregnancy_duration}</td></tr>
                    <tr><td> <b>Geo Location - Test - </b>  Latitude - {data.ts_lat} , Longitude - {data.ts_log}</td></tr>
                    <tr><td> <b>Venue - </b> {data.venue}</td></tr>
                    <tr><td> <b>Current Address - </b> {data.curr_address}</td></tr>
                    <tr><td> <b>Referral status - </b> {data.referral_status == 'reffered' ? "Referred" : "Not Referred"}</td></tr>
                    <tr><td> <b>Referred At - </b> {data.referred_center_name}</td></tr>
                    <tr><td> <b>Test done on - </b> <Moment format="DD-MM-YYYY" >{data.investigated_on}</Moment></td></tr>
                    <tr><td> <b>Test Done By - </b> {data.referral_status == 'reffered' ? data.test_hos_name : data.anm_med_nur_name}</td></tr>
                    <tr><td> <b>Referred By Hospital - </b> {data.referred_by_hos_name}</td></tr>
                  
                    <tr><td> <b>Added On - </b> <Moment format="DD-MM-YYYY" >{data.added_on}</Moment></td></tr>
                </table>
            </>

        )


    }







    const columns = [

        {
            name: 'Name',
            selector: row => row.name,
            cell: (row) => <Link to={'/recover_patient_all_test_list/' + row.patient_id + '/' + row.mobile_no + '/' + row.name} >{row.name}</Link>,
            sortable: true,
            // width: '110px',

        },

        {
            name: 'Beneficiary Type',
            selector: row => row.beneficiary_type,
            //   cellExport: row => row.beneficiary_type,
            sortable: true,

        },
        {
            name: 'Patient id',
            selector: row => row.patient_id,
            sortable: true,
            //   cellExport: row => row.patient_id,
            // width: '100px',
        },
        {
            name: 'Family Head Name',
            selector: row => row.guardian_name,
            //  cellExport: row => row.guardian_name,
            sortable: true,

        },

        {
            name: 'Mobile No',
            selector: row => row.mobile_no,
            sortable: true,
            //width: '75px',
            //  cellExport: row =>row.mobile_no,
            //cell: (row) => <Link to={'/patient_all_member_list/rp/' + row.mobile_no}>{row.mobile_no}</Link>
        },
        {
            name: 'Gender',
            selector: row => row.gender,
            sortable: true,
            //   cellExport: row =>row.gender,
            cell: (row) => <>{row.gender != null ? row.gender.toUpperCase() : ""}</>,

        },
        {
            name: "Caste",
            selector: row => row.caste,
            sortable: true,
            // cellExport: row =>row.caste,
            cell: (row) => <>{row.caste != null ? row.caste.toUpperCase() : ""}</>,

        },
        {
            name: "Age",
            selector: row => row.age,
            sortable: true,


        },

    ];


    let AllRecoveredSearchData = async (seeach) => {

        let datas = { page: pages, per_page: perPage, search: seeach };
        var url = "";

        url = 'admin/getSearchedServerSideRecoveredBeneficiary';

        const res = await axios.post(API_URL + url, datas)
            .then(ress => {
               
                setUserData(ress.data.Rdata);
              
            });
      
    }

    let TotalRecoveredData = async (serach) => {

        let datas = { search: serach };
        

        var url = "";

        url = 'admin/getSearchedServerSideRecoveredBeneficiaryTotal';

        const res = await axios.post(API_URL + url, datas)
            .then(ress => {
              
                setTotalRows(ress.data.Rdata.length);
                setTotalData(ress.data.Rdata);
                 setIsLoading(false);

            });

    }

    const handleSercahBox = (e) => {
        const inputValue = e.target.value;
        setSearchText(inputValue);
        AllRecoveredSearchData(inputValue);
        TotalRecoveredData(inputValue);

    }



    return (

        <div className="container-scroller">

            <Hor_header />

            <div className="container-fluid page-body-wrapper">

                <Ver_header />

                <div className="main-panel">
                    {isLoading ? (<Loader />) : (
                        <>
                            <div className="content-wrapper">



                                <div className="row">


                                    <div className="col-lg-12 grid-margin stretch-card">
                                        <div className="card">
                                            <div className="card-body">
                                                <h4 className="card-title">Recovered List {totalData.length !=0?"(Total no. of Recover Patient: "+totalData.length+")":""}</h4>
                                                <div className="row">
                                                    <div className="col-lg-6 grid-margin">
                                                        <button className="btn btn-success" onClick={dwn}  >Export List</button> &nbsp;
                                                        <button className="btn btn-success" onClick={dwnDetail}  >Export Detail List</button>
                                                      
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div className='cusSearch-box-item'>
                                                            <label>Search:
                                                                <input type='text' value={searchText} onChange={handleSercahBox} />
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>



                                                <div className="table-responsive">



                                                    <DataTable

                                                        columns={columns}
                                                        data={userData}
                                                        progressPending={loading}
                                                        pagination
                                                        paginationServer
                                                        paginationTotalRows={totalRows}
                                                        onChangeRowsPerPage={handlePerRowsChange}
                                                        onChangePage={handlePageChange}
                                                        expandableRows={true}
                                                        expandableRowsComponent={ExpandedComponent}
                                                    />



                                                </div>

                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>

                            <Footer />
                        </>
                    )}
                </div>

            </div>

        </div>);
}

export default AllRecoveredList;